import { isEmpty } from "lodash";
import React, { useContext, useRef, useState, useEffect } from "react";

import BetSlipContext from "../../context/BetSlipContext";
import { formatMarketAmount } from "./MarketHeader";

const BackandLay = ({
  back,
  lay,
  item,
  details,
  setSelectedBet,
  setKey,
  setSlipObj,
  slipObj,
  handelBetFairPositions,
  handelBookmakerPositions,
  setCondi,
  betType,
  betmode,
  amountRange,
  index,
  market,
  resetSelection,
  messaageBox,
  disabelBack,
  disabelLay,
  marketName,
  bookmakerObj,
  compact = false,
  depth = 1,
}) => {

  let { betSelectionObj, setBetSelectionObj, defaultStake, defaultOdds } =
    useContext(BetSlipContext);
  const myRef = useRef(null);
  const [id, setId] = useState({
    index: "",
    id: "",
    type: "",
  });
  
  // Track previous values for spark animation
  const prevBackBv = useRef(null);
  const prevBackRt = useRef(null);
  const prevLayBv = useRef(null);
  const prevLayRt = useRef(null);
  const [sparkBack, setSparkBack] = useState(false);
  const [sparkLay, setSparkLay] = useState(false);

  // Update spark animation when back odds change
  useEffect(() => {
    const currentBackBv = back[0]?.bv;
    const currentBackRt = back[0]?.rt;
    
    if (
      (prevBackBv.current !== null && prevBackBv.current !== currentBackBv) ||
      (prevBackRt.current !== null && prevBackRt.current !== currentBackRt)
    ) {
      setSparkBack(true);
      setTimeout(() => setSparkBack(false), 500);
    }
    
    prevBackBv.current = currentBackBv;
    prevBackRt.current = currentBackRt;
  }, [back[0]?.bv, back[0]?.rt]);

  // Update spark animation when lay odds change
  useEffect(() => {
    const currentLayBv = lay[0]?.bv;
    const currentLayRt = lay[0]?.rt;
    
    if (
      (prevLayBv.current !== null && prevLayBv.current !== currentLayBv) ||
      (prevLayRt.current !== null && prevLayRt.current !== currentLayRt)
    ) {
      setSparkLay(true);
      setTimeout(() => setSparkLay(false), 500);
    }
    
    prevLayBv.current = currentLayBv;
    prevLayRt.current = currentLayRt;
  }, [lay[0]?.bv, lay[0]?.rt]);

  const handleScroll = () => {
    setId({
      index: "",
      id: "",
      type: "",
    });
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handle = () => {
    // On desktop the betslip opens inline right under the selected row, so the
    // auto-scroll just causes an unwanted jump. Only scroll into view on mobile.
    const isDesktop = typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches;
    if (isDesktop) return;
    myRef?.current?.scrollIntoView();
  };
  useEffect(() => {
    handle();
  }, [id]);

  const backOdd = () => {
    if (betType === "bookmaker") {
      if (back[0]?.ms == 1) {
        return back[0]?.rt;
      } else {
        return null;
      }
    } else {
      return back[0]?.rt;
    }
  };
  const backOddSpan = () => {
    if (betType === "bookmaker") {
      // if (back[0]?.ms == 1) {
      //   return back[0]?.bv;
      // } else {
      return null;
      // }
    } else {
      return back[0]?.bv;
    }
  };

  const layOdd = () => {
    if (betType === "bookmaker") {
      if (lay[0]?.ms == 1) {
        return lay[0]?.rt;
      } else {
        return null;
      }
    } else {
      return lay[0]?.rt;
    }
  };
  const layOddSpan = () => {
    if (betType === "bookmaker") {
      // if (lay[0]?.ms == 1) {
      //   return lay[0]?.bv;
      // } else {
      return null;
      //}
    } else {
      return lay[0]?.bv;
    }
  };
  const compactCellStyle = {
    display: "flex", alignItems: "stretch", width: "100%", minWidth: 0,
    minHeight: "41px", height: "auto", margin: 0, padding: betType === "bookmaker" ? "3px" : 0,
    border: 0, boxSizing: "border-box", background: "transparent",
  };
  const compactOddsStyle = (side, quote) => {
    const baseActive = betSelectionObj?.priceToogle && betSelectionObj?.betType === betType &&
      slipObj?.SelectionId == item?.SelectionId && betSelectionObj?.layorback === side;
    // On the desktop 3-deep ladder each cell only lights up when ITS OWN price
    // is the selected one. Mobile (single cell / no quote) keeps the old
    // behaviour so nothing changes there.
    const active = depth === 3 && quote
      ? baseActive && Number(betSelectionObj?.oddsSelect) === Number(quote?.rt)
      : baseActive;
    return {
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      gap: "3px", position: "relative", width: "100%", minWidth: 0, minHeight: 0,
      margin: 0, padding: "3px 1px", boxSizing: "border-box", lineHeight: 1.1,
      border: betType === "bookmaker" ? "1px solid #fff" : "0 solid transparent",
      borderLeft: "1px solid #fff", borderRadius: betType === "bookmaker" ? "3px" : 0,
      background: side === "back" ? active ? "#168ee5" : "#72bbef" : active ? "#ef4770" : "#faa9ba",
      color: active ? "#fff" : "#111", boxShadow: active ? "inset 0 0 4px #0005" : "none",
      fontFamily: "Tahoma, Helvetica, sans-serif", fontSize: "12px", fontWeight: 700,
      textDecoration: "none",
    };
  };
  const compactAmountStyle = { display: "block", margin: 0, padding: 0, color: "inherit", fontSize: "11px", fontWeight: 400, lineHeight: 1.1 };

  // ── Shared bet handlers ──────────────────────────────────────────────────
  // Each odds cell (best + the two outer depth levels) places a bet at ITS OWN
  // price. `quote` is the { rt, bv } level for the clicked cell; passing it
  // through keeps the selected odds correct for every column.
  const placeBackBet = (quote) => {
    if (!quote) return;
    if (betType === "bookmaker" && Number(quote?.ms) !== 1) return;
    if (quote?.rt == null || market != "") return;
    if (back?.length === 0 || betmode == "off" || details?.sport_setting?.status == "inActive") return;
    if (Number(quote?.rt) == undefined || Number(quote?.rt) > amountRange?.oddsLimit) return;
    if (betType == "betFair" && disabelBack) return;
    if (amountRange?.oddsLimit === 0 || messaageBox) return;
    if (betSelectionObj.betType !== betType) resetSelection(betSelectionObj.betType);
    setKey(item?.SelectionId);
    setId({ index, id: item?.SelectionId, type: betType });
    setBetSelectionObj({
      ...betSelectionObj, betType, oddsSelect: quote?.rt, layorback: "back",
      bidPrice: defaultStake == 0 ? "" : defaultStake, inputType: "price",
      priceToogle: true, priceToogleType: "odds", expectany: defaultOdds,
      gameType: details?.gameType, minAmount: amountRange?.min, maxAmount: amountRange?.max,
      bmi: bookmakerObj?.bmi,
    });
    if (slipObj?.SelectionId == item?.SelectionId && betSelectionObj?.layorback == "back") {
      if (betType == "tie" || betType == "betFair") {
        handelBetFairPositions({ ...item, ...quote, teamName: item?.RunnerName, ...details });
      } else if (betType == "bookmaker") {
        handelBookmakerPositions({ ...item, ...quote, teamName: item?.RunnerName, ...details });
      }
    }
    setSlipObj({ ...item, ...quote, teamName: item?.RunnerName, ...details });
    setSelectedBet({ selectionId: item?.SelectionId, teamName: item?.RunnerName, check: "back", sid: item?.sid });
  };
  const placeLayBet = (quote) => {
    if (!quote) return;
    if (betType === "betFair" && marketName == "To Win the Toss") return;
    if (betType === "bookmaker" && Number(quote?.ms) !== 1) return;
    if (quote?.rt == null || market != "") return;
    if (lay?.length === 0 || betmode == "off" || details?.sport_setting?.status == "inActive") return;
    if (Number(quote?.rt) == undefined || Number(quote?.rt) > amountRange?.oddsLimit) return;
    if (betType == "betFair" && disabelLay) return;
    if (messaageBox) return;
    if (betSelectionObj.betType !== betType) resetSelection(betSelectionObj.betType);
    setKey(item?.SelectionId);
    setId({ index, id: item?.SelectionId, type: betType });
    setBetSelectionObj({
      ...betSelectionObj, betType, oddsSelect: quote?.rt, layorback: "lay",
      bidPrice: defaultStake == 0 ? "" : defaultStake, priceToogle: true,
      priceToogleType: "odds", gameType: details?.gameType, minAmount: amountRange?.min,
      maxAmount: amountRange?.max, expectany: defaultOdds, inputType: "price",
      bmi: bookmakerObj?.bmi,
    });
    if (slipObj?.SelectionId == item?.SelectionId && betSelectionObj?.layorback !== "lay") {
      if (betType == "tie" || betType == "betFair") {
        setCondi(true);
        handelBetFairPositions({ ...item, ...quote, teamName: item?.RunnerName, ...details });
      } else if (betType == "bookmaker") {
        handelBookmakerPositions({ ...item, ...quote, teamName: item?.RunnerName, ...details });
      }
    }
    setSlipObj({ ...item, ...quote, teamName: item?.RunnerName, ...details });
    setSelectedBet({ selectionId: item?.SelectionId, teamName: item?.RunnerName, check: "lay" });
  };

  // Ladder depth cell (desktop). An outer back/lay level that is ALSO
  // clickable — placing a bet at its own price. Styled lighter than the best
  // (innermost) cell so the primary price still stands out, matching the
  // reference. `quote` is one { rt, bv } level.
  const DepthCell = ({ side, quote }) => {
    const hasPrice = quote && Number(quote.rt) > 0;
    const disabled = !hasPrice || betmode == "off" || details?.sport_setting?.status == "inActive";
    // The depth cell lights up (dark) ONLY when this exact price is the
    // currently selected bet — so clicking an outer cell highlights THAT cell,
    // not the innermost one.
    const selected = betSelectionObj?.priceToogle && betSelectionObj?.betType === betType &&
      slipObj?.SelectionId == item?.SelectionId && betSelectionObj?.layorback === side &&
      hasPrice && Number(betSelectionObj?.oddsSelect) === Number(quote?.rt);
    const lightOddsStyle = {
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      gap: "3px", position: "relative", width: "100%", minWidth: 0, minHeight: 0,
      margin: 0, padding: "3px 1px", boxSizing: "border-box", lineHeight: 1.1,
      border: "0 solid transparent", borderLeft: "1px solid #fff", borderRadius: 0,
      background: selected
        ? (side === "back" ? "#168ee5" : "#ef4770")
        : (side === "back" ? "#cfe6f7" : "#f7d7de"),
      color: selected ? "#fff" : "#111",
      boxShadow: selected ? "inset 0 0 4px #0005" : "none",
      fontFamily: "Tahoma, Helvetica, sans-serif", fontSize: "12px", fontWeight: 700,
      textDecoration: "none", cursor: disabled ? "not-allowed" : "pointer",
    };
    return (
      <dd
        style={{ ...compactCellStyle, cursor: disabled ? "not-allowed" : "pointer" }}
        onClick={() => { if (!disabled) (side === "back" ? placeBackBet(quote) : placeLayBet(quote)); }}
      >
        <span style={lightOddsStyle}>
          {hasPrice ? quote.rt : "—"}
          <span style={compactAmountStyle}>{hasPrice ? quote.bv : ""}</span>
        </span>
      </dd>
    );
  };
  // Outer depth levels (index 1, 2). Back ladder renders worst→best (so the
  // best sits next to the center); lay renders best→worst.
  const showDepth = depth === 3;
  const backOuter = showDepth ? [back?.[2], back?.[1]] : [];
  const layOuter = showDepth ? [lay?.[1], lay?.[2]] : [];

  return (
    <>
      {backOuter.map((quote, i) => (
        <DepthCell key={`back-depth-${i}`} side="back" quote={quote} />
      ))}
      <dd
        id="back_1"
        onClick={() => placeBackBet(back[0])}
        style={{
          ...(compact ? compactCellStyle : {}),
          cursor: back?.length === 0 || betmode == "off" || details?.sport_setting?.status == "inActive" ? "not-allowed" : "pointer",
        }}
        className={
          back[0]?.rt == undefined ||
          back[0]?.rt == 0 ||
          details?.sport_setting?.status == "inActive"
            ? "single-disabled"
            : back[0]?.rt > amountRange?.oddsLimit
            ? "single-disabled"
            : betType == "betFair" && disabelBack
            ? "single-disabled"
            : ""
        }
      >
        <a
          ref={
            index == id.index &&
            betType == id.type &&
            (betType == "bookmaker" ? item?.selectionID : item?.SelectionId) ==
              id.id
              ? myRef
              : null
          }
          name={back[0]?.bv}
          title={back[0]?.rt}
          id={"back_odds_" + index}
          style={compact ? compactOddsStyle("back", back[0]) : undefined}
          className={
            slipObj?.teamName ==
              (betType == "betFair" ? item?.RunnerName : item?.runnerName) &&
            betSelectionObj?.layorback == "back" &&
            betSelectionObj.betType == betType &&
            betSelectionObj?.priceToogle &&
            (depth !== 3 || Number(betSelectionObj?.oddsSelect) === Number(back[0]?.rt))
              ? `back-1 select ${sparkBack ? "spark" : ""}`
              : `back-1 ${sparkBack ? "spark" : ""}`
          }
          href="javascript:void(0)"
        >
          {backOdd()}
          <span style={compact ? compactAmountStyle : undefined} title={compact && betType === "bookmaker" && back[0]?.bv == null ? "Available amount not provided" : undefined}>
            {compact && betType === "bookmaker" ? formatMarketAmount(back[0]?.bv) : backOddSpan()}
          </span>
        </a>
      </dd>
      <dd
        id="lay_1"
        onClick={() => placeLayBet(lay[0])}
        className={
          betType === "betFair" && marketName == "To Win the Toss"
            ? "single-disabled"
            : lay[0]?.rt == undefined ||
              lay[0]?.rt == 0 ||
              details?.sport_setting?.status == "inActive"
            ? "single-disabled"
            : lay[0]?.rt > amountRange?.oddsLimit
            ? "single-disabled"
            : ""
        }
        style={{
          ...(compact ? compactCellStyle : {}),
          cursor: (betType === "betFair" && marketName == "To Win the Toss") || lay?.length === 0 || betmode == "off" || details?.sport_setting?.status == "inActive" ? "not-allowed" : "pointer",
        }}
      >
        <a
          ref={
            index == id.index &&
            betType == id.type &&
            (betType == "bookmaker" ? item?.selectionID : item?.SelectionId) ==
              id.id
              ? myRef
              : null
          }
          id={"lay_odds_" + index}
          name={lay[0]?.bv}
          title={lay[0]?.rt}
          style={compact ? compactOddsStyle("lay", lay[0]) : undefined}
          className={
            slipObj?.teamName ==
              (betType == "betFair" ? item?.RunnerName : item?.runnerName) &&
            betSelectionObj?.layorback == "lay" &&
            betSelectionObj.betType == betType &&
            betSelectionObj?.priceToogle &&
            (depth !== 3 || Number(betSelectionObj?.oddsSelect) === Number(lay[0]?.rt))
              ? `lay-1 select ${sparkLay ? "spark" : ""}`
              : `lay-1 ${sparkLay ? "spark" : ""}`
          }
          href="javascript:void(0)"
        >
          {layOdd()}
          <span style={compact ? compactAmountStyle : undefined} title={compact && betType === "bookmaker" && lay[0]?.bv == null ? "Available amount not provided" : undefined}>
            {compact && betType === "bookmaker" ? formatMarketAmount(lay[0]?.bv) : layOddSpan()}
          </span>
        </a>
      </dd>
      {layOuter.map((quote, i) => (
        <DepthCell key={`lay-depth-${i}`} side="lay" quote={quote} />
      ))}
    </>
  );
};

export default BackandLay;
